import { ECarriersList } from './Carrier';

export enum SECTIONS {
	ENABLE_CLAIM_REVIEW = 'enableClaimReview',
	ENABLE_CLAIM_REKEY = 'enableClaimRekey',
	PAYMENT_TAX_FIELDS = 'paymentTaxFields',
	ENABLE_CLAIM_APPROVE = 'enableClaimApprove',
	ENABLE_CLAIM_REJECT = 'enableClaimReject',
	ENABLE_CLAIM_PENDING = 'enableClaimPending',
	ENABLE_CLAIM_REJECTION_DEFAULT_FIELDS = 'claimRejectionDefaultFields',
	ENABLE_CLAIM_REJECTION_ADDITIONAL_FIELDS = 'claimRejectionAdditionalFields',
	ENABLE_FRAUD = 'enableFraud',
	ENABLE_COMPLAINT = 'enableComplaint',
	REASON_CODES_REJECTED_EXTENDED = 'reasonCodesRejectedExtended',
	CLAIM_COMMENTS = 'claimComments',
}

export type SectionsListConfig = {
	[k in SECTIONS]: boolean;
};

export const SECTIONS_VISIBILITY_CONFIG: {
	[k in ECarriersList]: SectionsListConfig;
} = {
	[ECarriersList.BASIC_CARRIER]: {
		[SECTIONS.ENABLE_CLAIM_REVIEW]: false,
		[SECTIONS.ENABLE_CLAIM_REKEY]: true,
		[SECTIONS.PAYMENT_TAX_FIELDS]: false,
		[SECTIONS.ENABLE_CLAIM_APPROVE]: true,
		[SECTIONS.ENABLE_CLAIM_REJECT]: true,
		[SECTIONS.ENABLE_CLAIM_PENDING]: true,
		[SECTIONS.ENABLE_CLAIM_REJECTION_DEFAULT_FIELDS]: true,
		[SECTIONS.ENABLE_CLAIM_REJECTION_ADDITIONAL_FIELDS]: false,
		[SECTIONS.ENABLE_FRAUD]: false,
		[SECTIONS.ENABLE_COMPLAINT]: false,
		[SECTIONS.REASON_CODES_REJECTED_EXTENDED]: false,
		[SECTIONS.CLAIM_COMMENTS]: false,
	},
	[ECarriersList.FASCHIM_CARRIER]: {
		[SECTIONS.ENABLE_CLAIM_REVIEW]: true,
		[SECTIONS.ENABLE_CLAIM_REKEY]: false,
		[SECTIONS.PAYMENT_TAX_FIELDS]: true,
		[SECTIONS.ENABLE_CLAIM_APPROVE]: false,
		[SECTIONS.ENABLE_CLAIM_REJECT]: false,
		[SECTIONS.ENABLE_CLAIM_PENDING]: false,
		[SECTIONS.ENABLE_CLAIM_REJECTION_DEFAULT_FIELDS]: true,
		[SECTIONS.ENABLE_CLAIM_REJECTION_ADDITIONAL_FIELDS]: false,
		[SECTIONS.ENABLE_FRAUD]: false,
		[SECTIONS.ENABLE_COMPLAINT]: false,
		[SECTIONS.REASON_CODES_REJECTED_EXTENDED]: false,
		[SECTIONS.CLAIM_COMMENTS]: false,
	},
	[ECarriersList.CHUBB_CARRIER]: {
		[SECTIONS.ENABLE_CLAIM_REVIEW]: false,
		[SECTIONS.ENABLE_CLAIM_REKEY]: true,
		[SECTIONS.PAYMENT_TAX_FIELDS]: false,
		[SECTIONS.ENABLE_CLAIM_APPROVE]: true,
		[SECTIONS.ENABLE_CLAIM_REJECT]: true,
		[SECTIONS.ENABLE_CLAIM_PENDING]: true,
		[SECTIONS.ENABLE_CLAIM_REJECTION_DEFAULT_FIELDS]: false,
		[SECTIONS.ENABLE_CLAIM_REJECTION_ADDITIONAL_FIELDS]: true,
		[SECTIONS.ENABLE_FRAUD]: true,
		[SECTIONS.ENABLE_COMPLAINT]: true,
		[SECTIONS.REASON_CODES_REJECTED_EXTENDED]: false,
		[SECTIONS.CLAIM_COMMENTS]: true,
	},
	[ECarriersList.DECARE_CARRIER]: {
		[SECTIONS.ENABLE_CLAIM_REVIEW]: false,
		[SECTIONS.ENABLE_CLAIM_REKEY]: true,
		[SECTIONS.PAYMENT_TAX_FIELDS]: false,
		[SECTIONS.ENABLE_CLAIM_APPROVE]: true,
		[SECTIONS.ENABLE_CLAIM_REJECT]: true,
		[SECTIONS.ENABLE_CLAIM_PENDING]: true,
		[SECTIONS.ENABLE_CLAIM_REJECTION_DEFAULT_FIELDS]: true,
		[SECTIONS.ENABLE_CLAIM_REJECTION_ADDITIONAL_FIELDS]: false,
		[SECTIONS.ENABLE_FRAUD]: false,
		[SECTIONS.ENABLE_COMPLAINT]: false,
		[SECTIONS.REASON_CODES_REJECTED_EXTENDED]: true,
		[SECTIONS.CLAIM_COMMENTS]: false,
	},
};
